<template>
  <div class="blog-list">
    <h2 class="blog-list-title">最新文章</h2>
    <div class="articles">
      <article 
        v-for="article in displayedArticles" 
        :key="article.id" 
        class="article-card"
        @click="goToArticle(article.id)"
      >
        <div class="article-header">
          <h3 class="article-title">{{ article.title }}</h3>
          <time class="article-date">{{ formatDate(article.date) }}</time>
        </div>
        <p class="article-summary">{{ article.summary }}</p>
        <div class="article-footer">
          <div class="article-tags">
            <span v-for="tag in article.tags" :key="tag" class="tag">
              {{ tag }}
            </span>
          </div>
          <span class="read-more">阅读全文 →</span>
        </div>
      </article>
    </div>
    <div v-if="showLoadMore" class="load-more">
      <button @click="loadMore" class="load-more-btn">加载更多</button>
    </div>
  </div>
</template>

<script>
import { blogArticles, formatDate } from '@/utils/blog.js'

export default {
  name: 'BlogList',
  props: {
    limit: {
      type: Number,
      default: null // null 表示显示所有文章
    },
    showLoadMoreButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      articles: blogArticles,
      displayCount: this.limit || 3, // 默认显示3篇
      pageSize: 3
    }
  },
  computed: {
    displayedArticles() {
      if (this.limit) {
        return this.articles.slice(0, this.limit)
      }
      return this.articles.slice(0, this.displayCount)
    },
    showLoadMore() {
      return this.showLoadMoreButton && 
             this.displayCount < this.articles.length
    }
  },
  methods: {
    formatDate,
    goToArticle(articleId) {
      this.$router.push(`/blog/${articleId}`)
    },
    loadMore() {
      this.displayCount = Math.min(
        this.displayCount + this.pageSize, 
        this.articles.length
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.blog-list {
  margin-bottom: 2rem;
}

.blog-list-title {
  font-size: 1.5rem;
  margin: 0 0 1.5rem 0;
  color: #111;
  border-bottom: 2px solid #eee;
  padding-bottom: 0.5rem;
}

.articles {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.article-card {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 10px;
  padding: 1.5rem;
  box-shadow: 0 4px 14px rgba(0,0,0,.06);
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 8px 24px rgba(0,0,0,.12);
    transform: translateY(-2px);
    border-color: #ddd;
  }
}

.article-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
  gap: 1rem;
}

.article-title {
  margin: 0;
  font-size: 1.3rem;
  color: #111;
  flex: 1;
  line-height: 1.4;
}

.article-date {
  font-size: 0.9rem;
  color: #666;
  white-space: nowrap;
  flex-shrink: 0;
}

.article-summary {
  color: #555;
  line-height: 1.6;
  margin: 0 0 1rem 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.article-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.article-tags {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.tag {
  background: #f5f5f5;
  color: #666;
  padding: 0.2rem 0.6rem;
  border-radius: 15px;
  font-size: 0.8rem;
  border: 1px solid #eee;
}

.read-more {
  color: #007acc;
  font-size: 0.9rem;
  font-weight: 500;
  transition: color 0.3s ease;

  .article-card:hover & {
    color: #005fa3;
  }
}

.load-more {
  text-align: center;
  margin-top: 2rem;
}

.load-more-btn {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 2rem;
  border-radius: 25px;
  background: rgba(0, 122, 204, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 122, 204, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
  color: #007acc;

  &:hover {
    background: rgba(0, 122, 204, 0.25);
    transform: translateY(-2px);
    color: #005fa3;
    box-shadow: 0 8px 24px rgba(0, 122, 204, 0.2);
  }
}

@media (max-width: 768px) {
  .article-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .article-title {
    font-size: 1.2rem;
  }
  
  .article-footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
}
</style>
